import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { colors, fontFamily, maxWidth } from "./tokens";
import Reveal from "./Reveal";

const useStyles = makeStyles(theme => ({
  section: {
    padding: theme.spacing(8, 3),
    borderTop: `1px solid ${colors.border}`,
    borderBottom: `1px solid ${colors.border}`,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(6, 2.5)
    }
  },
  inner: {
    maxWidth,
    margin: "0 auto",
    textAlign: "center"
  },
  statement: {
    fontFamily,
    fontWeight: 600,
    fontSize: "clamp(1.3rem, 2.4vw, 1.75rem)",
    letterSpacing: "-0.01em",
    color: colors.ink,
    margin: 0,
    marginBottom: theme.spacing(1.5)
  },
  audience: {
    fontFamily,
    fontSize: 14.5,
    color: colors.inkMuted,
    margin: 0,
    marginBottom: theme.spacing(3.5)
  },
  list: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1.5),
    fontFamily,
    fontSize: 14,
    fontWeight: 500,
    color: colors.inkMuted
  },
  dot: {
    color: colors.inkFaint
  }
}));

const items = [
  "Assets",
  "Sites",
  "Requests",
  "Work Orders",
  "Technicians",
  "Inventory",
  "Suppliers",
  "Verification",
  "Reporting"
];

export default function PlatformStatement() {
  const classes = useStyles();

  return (
    <section id="platform" className={classes.section}>
      <div className={classes.inner}>
        <Reveal as="p" className={classes.statement}>
          One platform. Every maintenance operation.
        </Reveal>
        <Reveal as="p" className={classes.audience} delay={40}>
          Built for asset owners, maintenance providers and the teams who
          keep operations running.
        </Reveal>
        <Reveal as="div" className={classes.list} delay={80}>
          {items.map((item, i) => (
            <React.Fragment key={item}>
              <span>{item}</span>
              {i < items.length - 1 && <span className={classes.dot}>&middot;</span>}
            </React.Fragment>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
